import { SendImportContactsJsonData } from 'modules/contacts/contacts-import/hook/use-send-import-contacts/types'

export const transformSendImportContactsJsonDataToFormData = async ({
  file,
  delimiter,
  campaign,
  tags,
  selectedColumnsFrontend,
}: SendImportContactsJsonData) => {
  const selectedColumnsBackend = Object.entries(selectedColumnsFrontend)
    .sort(([keyA], [keyB]) => Number(keyA) - Number(keyB))
    .reduce(
      (resObj, [key, columnSelectOptionId]) => ({
        ...resObj,
        [`mapColumns[columns][${key}]`]: columnSelectOptionId || undefined,
      }),
      {},
    )

  const tagsBackend = tags?.reduce(
    (resObj, { id }) => ({ ...resObj, [`tags[${Object.entries(resObj).length}]`]: id }),
    {},
  )

  return {
    importFile: file,
    delimiter,
    campaign: campaign || undefined,
    ...selectedColumnsBackend,
    ...tagsBackend,
  }
}
